import { queryClient } from '../../../ReactQuery';
import useToastedMutation from '../../../ReactQuery/useToastedMutation';
import { remove } from '../../../redux/api';
import type { UserInvitation } from '../../../../shared/model-typings';

import { userInvitationsQueryKey } from './useUserInvitations';

/**
 * Delete a user invitation for a given email.
 */
function deleteUserInvitation(email: string) {
  return remove<null, null>(`/api/user-invitations/${email}`);
}

/**
 * Creates a mutation to delete a user invitation for a given email.
 * Note that the email is passed directly to the hook, and not the mutation function.
 * This is so that we can update the cache immediately after the mutation is successful.
 */
export default function useDeleteUserInvitation() {
  return useToastedMutation({
    mutationFn: deleteUserInvitation,
    successToastMessage: (_response, removedEmail: string) => `Invitation for ${removedEmail} removed.`,
    errorToastMessage: (_response, removedEmail: string) => `Failed to remove invitation for ${removedEmail}.`,
    onSuccess: (_response, removedEmail: string) => {
      //  This will update the cached value, which updates the UI right away.
      queryClient.setQueryData(userInvitationsQueryKey, (oldData: UserInvitation[] | undefined) => {
        return oldData?.filter(invite => invite.email !== removedEmail);
      });
    },
  });
}
